var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',{attrs:{"wrap":""}},[(_vm.value === null)?_c('fp-loader'):_c('v-flex',[_c('address-form',{attrs:{"value":_vm.value,"long-form":false,"required":_vm.required,"readonly":_vm.readonly}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }